import { useEffect } from "react"
import { useNavigate } from "../lib/router"

// Auth backend (register/login/me) — override via .env for non-local setups.
const API = process.env.REACT_APP_AUTH_API_URL || "http://localhost:8001"

export default function DashboardRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    async function checkStatus() {
      const token = localStorage.getItem("token")
      const role = localStorage.getItem("role")

      if (!token || !role) {
        navigate("/login")
        return
      }

      try {
        const res = await fetch(`${API}/api/auth/me`, {
          headers: { "Authorization": `Bearer ${token}` }
        })
        
        if (res.ok) {
          const me = await res.json()

          if (me.status === "pending") {
            navigate("/verification-pending")
            return
          }

          if (role === "admin") {
            navigate("/admin/dashboard")
          } else if (role === "club") {
            navigate("/club-admin/dashboard")
          } else if (role === "coach") {
            navigate("/coach/dashboard")
          } else if (role === "swimmer") {
            navigate("/swimmer/dashboard")
          } else {
            navigate("/login")
          }
        } else {
          // Invalid token
          navigate("/login")
        }
      } catch {
        navigate("/login")
      }
    }
    
    checkStatus()
  }, [navigate])

  return null
}
